/**
 *  @swagger
 *  definitions:
 *    ChampionshipAdminParams:
 *      type: object
 *      properties:
 *        ChampionshipId:
 *          description: ID of the associated Championship
 *          type: string
 *        AdminId:
 *          description: ID of the associated Admin
 *          type: string
 *
 *  @swagger
 *  definitions:
 *    ChampionshipAdminCreateParams:
 *      allOf:
 *        - $ref: '#/definitions/ChampionshipAdminParams'
 *        - type: object
 *          required:
 *            - ChampionshipId
 *            - AdminId
 *
 *  @swagger
 *  definitions:
 *    ChampionshipAdminQueryParams:
 *      allOf:
 *        - type: object
 *          properties:
 *            id:
 *              description: ID of the ChampionshipAdmin
 *              type: string
 *        - $ref: '#/definitions/ChampionshipAdminParams'
 *
 *  @swagger
 *  definitions:
 *    ChampionshipAdminUpdateParams:
 *      allOf:
 *        - $ref: '#/definitions/ChampionshipAdminQueryParams'
 *        - type: object
 *          required:
 *            - id
 *
 *  @swagger
 *  definitions:
 *    ChampionshipAdmin:
 *      allOf:
 *        - $ref: '#/definitions/ChampionshipAdminCreateParams'
 *        - $ref: '#/definitions/ChampionshipAdminUpdateParams'
 *        - $ref: '#/definitions/Timestamps'
 *
 *  @swagger
 *  components:
 *    schemas:
 *      ChampionshipAdmin:
 *        allOf:
 *          - $ref: '#/definitions/ChampionshipAdmin'
 *          - type: object
 *            properties:
 *              Championship:
 *                description: Championship of the ChampionshipAdmin
 *                $ref: '#/components/schemas/Championship'
 *              Admin:
 *                description: Admin of the ChampionshipAdmin
 *                $ref: '#/components/schemas/Admin'
 */

// Types
import type {
  $Model,
  $ModelClass,
  $ModelClasses,
} from '.';
import type {
  $Field,
} from '../types';

export type $RelationIds = {
  AdminId: string;
  ChampionshipId: string;
};
export type $CreateParams = $RelationIds;

export type $UpdateParams = {
  id: string;
} & Partial<$CreateParams>;

export type $UpsertParams = $CreateParams & {
  id?: string;
};

export type $QueryParams = {
  id?: null | string;
} & Partial<$CreateParams>;

export type $Associations = {
  Admin?: $Model<'Admin'>;
  Championship?: $Model<'Championship'>;
};

export type $ModelParams = $Associations & $CreateParams & {
  id: string;
};

type $Fields = {
  id: string;
};

const fields = (
  Sequelize,
): Record<keyof $Fields, $Field> => ({
  id: {
    allowNull: false,
    defaultValue: Sequelize.UUIDV4,
    primaryKey: true,
    type: Sequelize.UUID,
    unique: true,
  },
});

export default ((
  Sequelize,
  stack,
): $ModelClass<'ChampionshipAdmin'> => {
  const ChampionshipAdmin = stack.define(
    'ChampionshipAdmin',
    fields(Sequelize),
    {
      tableName: 'ChampionshipAdmins',
    },
  );

  ChampionshipAdmin.associate = (models: $ModelClasses) => {
    models.ChampionshipAdmin.belongsTo(
      models.Championship,
      {
        as: 'Championship',
        foreignKey: 'ChampionshipId',
      },
    );
    models.ChampionshipAdmin.belongsTo(
      models.Admin,
      {
        as: 'Admin',
        foreignKey: 'AdminId',
      },
    );
  };

  return ChampionshipAdmin;
});
